const INITIAL_STATE = {
  tarifarioCategorias: {data:[]},
  tarifarioCategoriaSelectOption: []
}
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'TARIFARIO_GRUPO_FETCH':
        return { ...state, tarifarioCategorias: action.payload }
        case 'TARIFARIO_CATEGORIA_SELECT_OPTION':
          return { ...state, tarifarioCategoriaSelectOption: action.payload }
      default:
        return state
    }
  }